import { budgetEstimatorEmail } from "@/lib/database/client/database";
import { createClient } from "@/utils/supabase/client";

import { ESTIMATES_PATH, PUBLIC_ESTIMATOR_LEAD_SOURCE } from "../constants";

/**
 * Saves a public estimator visitor's email as a lead, in the same table and with the same
 * team notice the old budget estimator used, tagged with where it came from.
 * @param email - The visitor's normalized email.
 * @returns Once the lead is written.
 * @throws When the insert fails, so the gate shows its retry message instead of moving on.
 */
export async function saveEstimatorLead(email: string): Promise<void> {
  await budgetEstimatorEmail(createClient(), email, { source: PUBLIC_ESTIMATOR_LEAD_SOURCE });
}

/**
 * Sign-up for a visitor from the public estimator: the login page with their email filled in,
 * landing on the dashboard estimator once they are in.
 * @param email - The visitor's email.
 * @returns The login URL.
 * @throws Never.
 */
export const signupHref = (email: string): string =>
  `/login?${new URLSearchParams({ redirect: ESTIMATES_PATH, email }).toString()}`;
